import apiClient from "./apiClient";

export const getAllEnqueries = (page = 1, limit = 10) => {
    return apiClient.get(`/Enqueries/All?page=${page}&limit=${limit}`);
};

export const exportEnqueries = () => {
    return apiClient.get('/Enqueries/Export', { responseType: 'blob' });
};

